import { render, staticRenderFns } from "./StorageSettings.vue?vue&type=template&id=1d2be549&scoped=true"
import script from "./StorageSettings.vue?vue&type=script&lang=js"
export * from "./StorageSettings.vue?vue&type=script&lang=js"
import style0 from "./StorageSettings.vue?vue&type=style&index=0&id=1d2be549&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2be549",
  null
  
)

export default component.exports